import React from "react";
import PropTypes from "prop-types";
import ReactPagination from "react-js-pagination";

import { isMiniSize, scrollTop, debounce } from "@/utils";

class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: props.pageIndex || 1,
      pageSize: 1,
    };

    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.resizeDebounce);
  }

  componentDidUpdate(prevProps, prevState) {
    const { pageIndex } = this.props;
    if (prevProps.pageIndex !== pageIndex) {
      this.setState({ activePage: pageIndex });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  resize = () => {
    const { pageRangeDisplayed, mobilePageRangeDisplayed } = this.props;
    this.setState({
      pageSize: isMiniSize() ? mobilePageRangeDisplayed : pageRangeDisplayed,
    });
  };

  onChange = (page) => {
    const { onChange } = this.props;
    const { activePage } = this.state;
    if (activePage !== page) {
      this.setState({ activePage: page });
      onChange && onChange(page);
      scrollTop();
    }
  };

  render() {
    const { activePage, pageSize } = this.state;
    const { totalPage } = this.props;
    if (totalPage === 1) {
      return null;
    }
    return (
      <ReactPagination
        innerClass="pagination pagination-inner"
        itemClass="pagination-item"
        linkClass="pagination-link"
        activeClass="pagination-active"
        activeLinkClass="pagination-active-link"
        itemClassFirst="pagination-item-first"
        itemClassPrev="pagination-item-prev"
        itemClassNext="pagination-item-next"
        itemClassLast="pagination-item-last"
        linkClassFirst="pagination-link-first"
        linkClassPrev="pagination-link-prev"
        linkClassNext="pagination-link-next"
        linkClassLast="pagination-link-last"
        disabledClass="pagination-disabled"
        prevPageText="‹"
        nextPageText="›"
        totalItemsCount={totalPage}
        itemsCountPerPage={1}
        pageRangeDisplayed={pageSize}
        activePage={activePage}
        onChange={this.onChange}
      />
    );
  }
}

Pagination.propTypes = {
  pageRangeDisplayed: PropTypes.number,
  mobilePageRangeDisplayed: PropTypes.number,
  totalPage: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  pageIndex: PropTypes.number,
};

Pagination.defaultProps = {
  pageRangeDisplayed: 6,
  mobilePageRangeDisplayed: 3,
  pageIndex: 1,
};

export default Pagination;
